export default __webpack_public_path__ + "static/media/user.755cdd9c.png";